<template>
  <b-container v-if="config && config.mlbtv">
    <b-row>
      <b-col class="px-0">
        <b-card
          no-body
          header="Default Background"
          class="mt-0">
          <b-card-body>
            <optional-form
              :show="!!config.mlbtv.defaultBackground"
              @add="$set(config.mlbtv, 'defaultBackground', defaultImageAndTemplate())">
              <logo-upload
                v-if="config.mlbtv.defaultBackground"
                ref="default_background"
                v-model="config.mlbtv.defaultBackground.imageUrl"
                :can-edit="canBrandingEdit"
                label="Image URL"
                ref-id="createImageURL"
                accept="image/*"
                extensions="jpg,jpeg,png">
                <template #additional-label>
                  <b-form-group
                    label="Template URL"
                    :description="config.mlbtv.defaultBackground.templateUrl" />
                </template>
              </logo-upload>
            </optional-form>
          </b-card-body>
        </b-card>
        <b-card
          no-body
          header="Welcome Images"
          class="mt-0">
          <b-card-body>
            <optional-form
              :show="!!config.mlbtv.welcome"
              @add="$set(config.mlbtv, 'welcome', defaultWelcomeImageAndTemplate())">
              <div v-if="!!config.mlbtv.welcome">
                <logo-upload
                  ref="create"
                  v-model="config.mlbtv.welcome.create.imageUrl"
                  :can-edit="canBrandingEdit"
                  label="Create Image URL"
                  ref-id="createImageURL"
                  accept="image/*"
                  extensions="jpg,jpeg,png">
                  <template #additional-label>
                    <b-form-group
                      label="Template URL"
                      :description="config.mlbtv.welcome.create.templateUrl" />
                  </template>
                </logo-upload>
                <hr>
                <logo-upload
                  ref="browse"
                  v-model="config.mlbtv.welcome.browse.imageUrl"
                  :can-edit="canBrandingEdit"
                  label="Browse Image URL"
                  ref-id="browseImageUrl"
                  accept="image/*"
                  extensions="jpg,jpeg,png">
                  <template #additional-label>
                    <b-form-group
                      label="Template URL"
                      :description="config.mlbtv.welcome.browse.templateUrl" />
                  </template>
                </logo-upload>
                <hr>
                <logo-upload
                  ref="explore"
                  v-model="config.mlbtv.welcome.explore.imageUrl"
                  :can-edit="canBrandingEdit"
                  label="Explore Image URL"
                  ref-id="explore"
                  accept="image/*"
                  extensions="jpg,jpeg,png">
                  <template #additional-label>
                    <b-form-group
                      label="Template URL"
                      :description="config.mlbtv.welcome.explore.templateUrl" />
                  </template>
                </logo-upload>
              </div>
            </optional-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import LogoUpload from "./LogoUpload"
  import {mapGetters} from "vuex"
  import OptionalForm from "@/components/OptionalForm"

  export default {
    name: "MlbTvForm",
    components: {
      OptionalForm,
      LogoUpload,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        "canBrandingEdit",
      ]),
      config: {
        get: function () {
          if (!this.value.mlbtv) {
              this.$set(this.value, 'mlbtv', {})
          }
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
    },
    watch: {
      'config.mlbtv.defaultBackground.imageUrl'(newValue) {
        if (newValue) {
          this.config.mlbtv.defaultBackground.templateUrl = newValue.replace(/\/oms\//, "/${options}/oms/")
          console.log("updating defaultBackground templateUrl", this.config.mlbtv.defaultBackground.templateUrl)
        }
      },
      'config.mlbtv.welcome.create.imageUrl'(newValue) {
        if (newValue) {
          this.config.mlbtv.welcome.create.templateUrl = newValue.replace(/\/oms\//, "/${options}/oms/")
          console.log("updating create templateUrl", this.config.mlbtv.welcome.create.templateUrl)
        }
      },
      'config.mlbtv.welcome.browse.imageUrl'(newValue) {
        if (newValue) {
          this.config.mlbtv.welcome.browse.templateUrl = newValue.replace(/\/oms\//, "/${options}/oms/")
          console.log("updating browse templateUrl", this.config.mlbtv.welcome.browse.templateUrl)
        }
      },
      'config.mlbtv.welcome.explore.imageUrl'(newValue) {
        if (newValue) {
          this.config.mlbtv.welcome.explore.templateUrl = newValue.replace(/\/oms\//, "/${options}/oms/")
          console.log("updating explore templateUrl", this.config.mlbtv.welcome.explore.templateUrl)
        }
      },
    },
    methods: {
      defaultImageAndTemplate() {
        return {
          imageUrl: "",
          templateUrl: "",
        }
      },
      defaultWelcomeImageAndTemplate() {
        return {
          create: this.defaultImageAndTemplate(),
          browse: this.defaultImageAndTemplate(),
          explore: this.defaultImageAndTemplate(),
        }
      },
    },
  }
</script>

<style scoped>
.card {
  margin: 1.5rem 0;
}

.asset-action-icon {
  cursor: pointer;
  max-height: 16px;
  max-width: 16px;
}
</style>
